export default __webpack_public_path__ + "fdf4d891940d0246239d776205c23b56.svg";